<template lang="pug">
.container-fluid.animated.fadeIn
  nav(aria-label="breadcrumb")
    b-breadcrumb
      b-breadcrumb-item
        router-link(to="/report")
          i.fa.fa-chart-line
          span.ml-1 {{ $t("title.reports") }}
      b-breadcrumb-item
        router-link(to="/report/dailyWinLose")
          i.fa.fa-table
          span.ml-1 {{ $t("title.daily_winlose") }}
          //- span | {{ target_id }} | {{ parentId }}
  //- .row
  //-   .col
  //-     span {{ selectedResult }}
  .row
    .col-md-12
      .form-row
        .col-xs-10.col-sm-6.col-md-4.col-lg-4.mb-1
          b-input-group(size="sm")
            b-input-group-text(slot="prepend")
              i.icon-user
            DebounceInput(
              type="search"
              v-model.trim.lazy="search_id"
              :placeholder="$t('ui.account_id')"
              :disabled="loading"
            )
            b-input-group-text(slot="append").p-0
              .btn.btn-append(@click="back()")
                i.fa.fa-chevron-left
                span {{ $t("ui.back") }}

        .col-xs-10.col-sm-6.col-md-2.col-lg-2.mb-1
          b-input-group(size="sm")
            b-input-group-text(slot="prepend")
              i.icon-question
            b-form-select(v-model="report_type")
              option(value="ALL") {{ $t('title.ALL') }}
              option(value="SPORTSBOOK") {{ $t('title.SPORTSBOOK') }}
              option(value="LIVECASINO") {{ $t('title.LIVECASINO') }}
              option(value="SLOTS") {{ $t("title.SLOTS") }}
              option(value="LOTTERY") {{ $t("title.LOTTERY") }}
        .col-xs-10.col-sm-6.col-md-3.col-lg-3.mb-1
          DateRangePicker(:title="$t('ui.date_range')" :value="dateRange")
        .col-xs-2.col-sm-2.col-md-2.col-lg-2.mb-1
          SubmitButton(
            :loading="loading"
            icon="fa fa-search"
            :text="$t('ui.search')"
            type="button"
            @click="getList"
            variant="success"
            size="sm"
            )

  b-row
    b-col
      b-breadcrumb.py-1.px-2.mb-1.text-xs.rounded-1
        b-breadcrumb-item(@click="drillIn()")
          span {{ $t("ui.company") }}
        b-breadcrumb-item(
          v-for="(item, index) in agent.lines"
          :key="index"
          :text="item.account_id"
          :class="{ active: index==agent.lines.length - 1 }"
          @click="drillIn(item.account_id)"
        )

  //- AGENT
  .row
    .col-md-12
      .card.mb-1
        .card-header.p-2.bg-gradient-light
          i.fa.fa-user-secret
          span {{ $t("title.agent") }}
        .card-body.p-1
          b-row
            .col-md-10
              b-pagination.float-left(
                size="sm"
                hide-ellipsis
                :total-rows="agent.totalRows"
                :per-page="perPage"
                v-model="agent.currentPage"
                @input="agentChangedPage($event)").mb-1
            .col-md-2
              b-input-group(:prepend="$t('ui.page_size')" size="sm").mb-1
                b-form-select(:options="$store.getters.pageSizeOptions" :value="perPage" @input="changedPageSize")

          b-row
            .col-sm-12.col-md-12.col-lg-12.col-xl-12
              .table-responsive.mb-0
                //- AGENT - MAIN
                table#agentList.table.b-table.c-table(role="table", aria-busy="false" style="min-width: 800px;")
                  thead(role="rowgroup")
                    tr(role="row")
                      th(role="columnheader", scope="col", style="width: 160px;")
                        div {{ $t("ui.account_id") }}
                      th.text-left(role="columnheader", scope="col")
                        div {{ $t("ui.full_name") }}
                      th.text-right(role="columnheader", scope="col", style="width: 100px;")
                        div {{ $t("ui.bet_count") }}
                      th.text-right(role="columnheader", scope="col", style="width: 120px;")
                        div {{ $t("ui.turnover") }}
                      th.text-right(role="columnheader", scope="col", style="width: 120px;")
                        div {{ $t("ui.valid_turnover") }}
                      th.text-right(role="columnheader", scope="col", style="width: 120px;")
                        div {{ $t("ui.winlose") }}
                  tbody(v-if="agent.list.length > 0" role="rowgroup")
                    template(v-for="(item, index) in agent.list")
                      tr(role="row")
                        td(role="cell")
                          .text-left.d-flex.align-items-center.justify-content-start
                            .btn.btn-sm.btn-v(@click="selectAgentProvider(item)")
                              i.fa.fa-folder-open.mr-0(v-if="item['expand']" aria-hidden="true")
                              i.fa.fa-folder.mr-0(v-else aria-hidden="true")
                            .text-left.text-link
                              span.cursor-pointer(@click="drillIn(item.account_id)") #[b {{ item.account_id }}]
                        td(role="cell")
                          .text-left
                            span {{ item.full_name }}
                        td(role="cell")
                          .text-right
                            span(
                              :class="$helpers.getNumberClass(item.bet_count)"
                              )
                              | {{ item.bet_count }}
                        td(role="cell")
                          .text-right
                            span(
                              :class="$helpers.getNumberClass(item.turnover)"
                              )
                              | #[b {{ item.turnover | currency }}]
                        td(role="cell")
                          .text-right
                            span(
                              :class="$helpers.getNumberClass(item.valid_turnover)"
                              )
                              | #[b {{ item.valid_turnover | currency }}]
                        td(role="cell")
                          .text-right
                            span(
                              :class="$helpers.getNumberClass(item.winlose)"
                              )
                              | #[b {{ item.winlose | currency }}]
                      //- AGENT - PROVIDER
                      tr(v-if="item['expand']" role="row")
                        td(role="cell" colspan=6 style="padding: 0 0 8px 8px; border: 0")
                          table.table.b-table.c-table.p-table(role="table", aria-busy="false")
                            tbody(v-if="item['provider_list'] && item['provider_list'].length > 0" role="rowgroup")
                              template(v-for="pr in item['provider_list']")
                                tr(role="row")
                                  td(role="cell")
                                    .text-left.d-flex.align-items-center.justify-content-start
                                      .btn.btn-sm.btn-v(@click="selectAgentCode(item, pr)")
                                        i.fa.fa-folder-open.mr-0(v-if="pr['expand']" aria-hidden="true")
                                        i.fa.fa-folder.mr-0(v-else aria-hidden="true")
                                      .text-left.text-link
                                        span {{ pr.provider_type }}
                                  td(role="cell" style="width: 100px;")
                                    .text-right
                                      span(
                                        :class="$helpers.getNumberClass(pr.bet_count)"
                                        )
                                        | {{ pr.bet_count }}
                                  td(role="cell" style="width: 120px;")
                                    .text-right
                                      span(
                                        :class="$helpers.getNumberClass(pr.turnover)"
                                        )
                                        | #[b {{ pr.turnover | currency }}]
                                  td(role="cell" style="width: 120px;")
                                    .text-right
                                      span(
                                        :class="$helpers.getNumberClass(pr.valid_turnover)"
                                        )
                                        | #[b {{ pr.valid_turnover | currency }}]
                                  td(role="cell" style="width: 120px;")
                                    .text-right
                                      span(
                                        :class="$helpers.getNumberClass(pr.winlose)"
                                        )
                                        | #[b {{ pr.winlose | currency }}]
                                //- AGENT - CODE
                                tr(v-if="pr['expand']" role="row" style="background: #f9f8fa;")
                                  td(role="cell" colspan=5 style="padding: 0 0 8px 8px; border: 0;")
                                    table.table.b-table.c-table.p-table(role="table", aria-busy="false")
                                      tbody(v-if="pr['code_list'] && pr['code_list'].length > 0" role="rowgroup")
                                        template(v-for="co in pr['code_list']")
                                          tr(role="row")
                                            td(role="cell")
                                              .text-left.d-flex.align-items-center.justify-content-start
                                                .btn.btn-sm.btn-v(style="cursor: auto;")
                                                  i.fa.fa-folder-open.mr-0(aria-hidden="true" style="color: #88888888;")
                                                .text-left.text-link
                                                  span {{ co.provider_code }}
                                            td(role="cell" style="width: 100px;")
                                              .text-right
                                                span(
                                                  :class="$helpers.getNumberClass(co.bet_count)"
                                                  )
                                                  | {{ co.bet_count }}
                                            td(role="cell" style="width: 120px;")
                                              .text-right
                                                span(
                                                  :class="$helpers.getNumberClass(co.turnover)"
                                                  )
                                                  | #[b {{ co.turnover | currency }}]
                                            td(role="cell" style="width: 120px;")
                                              .text-right
                                                span(
                                                  :class="$helpers.getNumberClass(co.valid_turnover)"
                                                  )
                                                  | #[b {{ co.valid_turnover | currency }}]
                                            td(role="cell" style="width: 119.5px;")
                                              .text-right
                                                span(
                                                  :class="$helpers.getNumberClass(co.winlose)"
                                                  )
                                                  | #[b {{ co.winlose | currency }}]
                  tbody(v-else)
                    tr
                      td(colspan=6)
                        .text-center.p-2
                          span.text-zero {{ $t('message.no_records') }}
                  tfoot(v-if="agent.list.length > 0")
                    tr(role="row")
                      td(role="cell" colspan="2")
                        .text-right.text-uppercase.text-zero
                          b {{ $t("ui.total") }}
                      td(role="cell")
                        .text-right
                          span(
                            :class="$helpers.getNumberClass(agent.total.bet_count)"
                            )
                            | {{ agent.total.bet_count }}
                      td(role="cell")
                        .text-right
                          span(
                            :class="$helpers.getNumberClass(agent.total.turnover)"
                            )
                            | #[b {{ agent.total.turnover | currency }}]
                      td(role="cell")
                        .text-right
                          span(
                            :class="$helpers.getNumberClass(agent.total.valid_turnover)"
                            )
                            | #[b {{ agent.total.valid_turnover | currency }}]
                      td(role="cell")
                        .text-right
                          span(
                            :class="$helpers.getNumberClass(agent.total.winlose)"
                            )
                            | #[b {{ agent.total.winlose | currency }}]

  //- MEMBER
  .row
    .col-md-12
      .card.mb-1
        .card-header.p-2.bg-gradient-light
          i.fa.fa-user
          span {{ $t("title.member") }}
        .card-body.p-1
          b-row
            .col-md-10
              b-pagination.float-left(
                size="sm"
                hide-ellipsis
                :total-rows="member.totalRows"
                :per-page="perPage"
                v-model="member.currentPage"
                @input="memberChangedPage($event)").mb-1
            .col-md-2
              //- b-input-group(:prepend="$t('ui.page_size')" size="sm").mb-1
              //-   b-form-select(:options="$store.getters.pageSizeOptions" :value="perPage" @input="changedPageSize")
          b-row
            .col-sm-12.col-md-12.col-lg-12.col-xl-12
              .table-responsive.mb-0
                //- MEMBER - MAIN
                table#memberList.table.b-table.c-table(role="table", aria-busy="false" style="min-width: 800px;")
                  thead(role="rowgroup")
                    tr(role="row")
                      th(role="columnheader", scope="col", style="width: 160px;")
                        div {{ $t("ui.account_id") }}
                      th.text-left(role="columnheader", scope="col")
                        div {{ $t("ui.full_name") }}
                      th.text-right(role="columnheader", scope="col", style="width: 100px;")
                        div {{ $t("ui.bet_count") }}
                      th.text-right(role="columnheader", scope="col", style="width: 120px;")
                        div {{ $t("ui.turnover") }}
                      th.text-right(role="columnheader", scope="col", style="width: 120px;")
                        div {{ $t("ui.valid_turnover") }}
                      th.text-right(role="columnheader", scope="col", style="width: 120px;")
                        div {{ $t("ui.winlose") }}
                  tbody(v-if="member.list.length > 0" role="rowgroup")
                    template(v-for="(item, index) in member.list")
                      tr(role="row")
                        td(role="cell")
                          .text-left.d-flex.align-items-center.justify-content-start
                            .btn.btn-sm.btn-v(@click="selectMemberProvider(item)")
                              i.fa.fa-folder-open.mr-0(v-if="item['expand']" aria-hidden="true")
                              i.fa.fa-folder.mr-0(v-else aria-hidden="true")
                            .text-left.text-link
                              span {{ item.account_id }}
                        td.text-left(role="cell")
                          .text-left
                            span {{ item.full_name }}
                        td(role="cell")
                          .text-right
                            span(
                              :class="$helpers.getNumberClass(item.bet_count)"
                              )
                              | {{ item.bet_count }}
                        td(role="cell")
                          .text-right
                            span(
                              :class="$helpers.getNumberClass(item.turnover)"
                              )
                              | #[b {{ item.turnover | currency }}]
                        td(role="cell")
                          .text-right
                            span(
                              :class="$helpers.getNumberClass(item.valid_turnover)"
                              )
                              | #[b {{ item.valid_turnover | currency }}]
                        td(role="cell")
                          .text-right
                            span(
                              :class="$helpers.getNumberClass(item.winlose)"
                              )
                              | #[b {{ item.winlose | currency }}]
                      //- MEMBER - PROVIDER
                      tr(v-if="item['expand']" role="row")
                        td(role="cell" colspan=6 style="padding: 0 0 8px 8px; border: 0")
                          table.table.b-table.c-table.p-table(role="table", aria-busy="false")
                            tbody(v-if="item['provider_list'] && item['provider_list'].length > 0" role="rowgroup")
                              template(v-for="pr in item['provider_list']")
                                tr(role="row")
                                  td(role="cell")
                                    .text-left.d-flex.align-items-center.justify-content-start
                                      .btn.btn-sm.btn-v(@click="selectMemberCode(item, pr)")
                                        i.fa.fa-folder-open.mr-0(v-if="pr['expand']" aria-hidden="true")
                                        i.fa.fa-folder.mr-0(v-else aria-hidden="true")
                                      .text-left.text-link
                                        span {{ pr.provider_type }}
                                  td(role="cell" style="width: 100px;")
                                    .text-right
                                      span(
                                        :class="$helpers.getNumberClass(pr.bet_count)"
                                        )
                                        | {{ pr.bet_count }}
                                  td(role="cell" style="width: 120px;")
                                    .text-right
                                      span(
                                        :class="$helpers.getNumberClass(pr.turnover)"
                                        )
                                        | #[b {{ pr.turnover | currency }}]
                                  td(role="cell" style="width: 120px;")
                                    .text-right
                                      span(
                                        :class="$helpers.getNumberClass(pr.valid_turnover)"
                                        )
                                        | #[b {{ pr.valid_turnover | currency }}]
                                  td(role="cell" style="width: 120px;")
                                    .text-right
                                      span(
                                        :class="$helpers.getNumberClass(pr.winlose)"
                                        )
                                        | #[b {{ pr.winlose | currency }}]
                                //- MEMBER - CODE
                                tr(v-if="pr['expand']" role="row" style="background: #f9f8fa;")
                                  td(role="cell" colspan=5 style="padding: 0 0 8px 8px; border: 0;")
                                    table.table.b-table.c-table.p-table(role="table", aria-busy="false")
                                      tbody(v-if="pr['code_list'] && pr['code_list'].length > 0" role="rowgroup")
                                        template(v-for="co in pr['code_list']")
                                          tr(role="row")
                                            td(role="cell")
                                              .text-left.d-flex.align-items-center.justify-content-start
                                                .btn.btn-sm.btn-v(style="cursor: auto;")
                                                  i.fa.fa-folder.mr-0(aria-hidden="true" style="color: #88888888;")
                                                .text-left.text-link
                                                  span.cursor-pointer(@click="selectMemberResult(co)") #[b {{ co.provider_code }}]
                                            td(role="cell" style="width: 100px;")
                                              .text-right
                                                span(
                                                  :class="$helpers.getNumberClass(co.bet_count)"
                                                  )
                                                  | {{ co.bet_count }}
                                            td(role="cell" style="width: 120px;")
                                              .text-right
                                                span(
                                                  :class="$helpers.getNumberClass(co.turnover)"
                                                  )
                                                  | #[b {{ co.turnover | currency }}]
                                            td(role="cell" style="width: 120px;")
                                              .text-right
                                                span(
                                                  :class="$helpers.getNumberClass(co.valid_turnover)"
                                                  )
                                                  | #[b {{ co.valid_turnover | currency }}]
                                            td(role="cell" style="width: 119.5px;")
                                              .text-right
                                                span(
                                                  :class="$helpers.getNumberClass(co.winlose)"
                                                  )
                                                  | #[b {{ co.winlose | currency }}]
                  tbody(v-else)
                    tr
                      td(colspan=6)
                        .text-center.p-2
                          span.text-zero {{ $t('message.no_records') }}
                  tfoot(v-if="member.list.length > 0")
                    tr(role="row")
                      td(role="cell" colspan="2")
                        .text-right.text-uppercase.text-zero
                          b {{ $t("ui.total") }}
                      td(role="cell")
                        .text-right
                          span(
                            :class="$helpers.getNumberClass(member.total.bet_count)"
                            )
                            | {{ member.total.bet_count }}
                      td(role="cell")
                        .text-right
                          span(
                            :class="$helpers.getNumberClass(member.total.turnover)"
                            )
                            | #[b {{ member.total.turnover | currency }}]
                      td(role="cell")
                        .text-right
                          span(
                            :class="$helpers.getNumberClass(member.total.valid_turnover)"
                            )
                            | #[b {{ member.total.valid_turnover | currency }}]
                      td(role="cell")
                        .text-right
                          span(
                            :class="$helpers.getNumberClass(member.total.winlose)"
                            )
                            | #[b {{ member.total.winlose | currency }}]

  //- RESULT
  .row(v-if="result.list.length > 0")
    .col-md-12
      .card.mb-1
        .card-header.p-2.bg-gradient-light
          .d-flex.align-items-center.justify-content-start
            i.fa.fa-gamepad.mr-2
            span.mr-2 {{ $t("title." + result.item.provider_type) }} - {{ result.item.provider_code }}
            .tag {{ result.item.account_id }}
        .card-body.p-1
          b-row
            .col-md-10
              b-pagination.float-left(
                size="sm"
                hide-ellipsis
                :total-rows="result.totalRows"
                :per-page="perPage"
                v-model="result.currentPage"
                @input="resultChangedPage($event)").mb-1
            .col-md-2
              //- b-input-group(:prepend="$t('ui.page_size')" size="sm").mb-1
              //-   b-form-select(:options="$store.getters.pageSizeOptions" :value="perPage" @input="changedPageSize")
          b-row
            .col-sm-12.col-md-12.col-lg-12.col-xl-12
              .table-responsive.mb-0
                //- MEMBER - MAIN
                table#resultList.table.b-table.c-table(role="table", aria-busy="false")
                  thead(role="rowgroup")
                    tr(role="row")
                      th.text-left(role="columnheader", scope="col", style="width: 160px;")
                        div {{ $t("ui.id") }}
                      th.text-left(role="columnheader", scope="col", style="width: 100px;")
                        div {{ $t("ui.date_time") }}
                      th.text-left(role="columnheader", scope="col")
                        div {{ $t("ui.details") }}
                      th.text-right(role="columnheader", scope="col", style="width: 120px;")
                        div {{ $t("ui.turnover") }}
                      th.text-right(role="columnheader", scope="col", style="width: 120px;")
                        div {{ $t("ui.valid_turnover") }}
                      th.text-right(role="columnheader", scope="col", style="width: 120px;")
                        div {{ $t("ui.winlose") }}
                  tbody(v-if="result.list.length > 0" role="rowgroup")
                    template(v-for="(item, index) in result.list")
                      tr(role="row")
                        td(role="cell")
                          .text-left.text-truncate.text-link
                            span.cursor-pointer(@click="openLink(item)") #[b {{ item.result_id }}]
                        td.text-left(role="cell")
                          .d-block.text-primary(style="line-height: 1;") {{ $moment(item.bet_time).format('DD/MM/YYYY') }}
                          .d-block.text-zero(style="line-height: 1;") {{ $moment(item.bet_time).format('HH:mm:ss A') }}
                        td.text-left(role="cell" style="padding: 4px;")
                          template(v-if="result.item.provider_type == 'LIVECASINO'")
                            table.table-details
                              tbody
                                tr(v-if="item.game_name")
                                  td.table-header(style="width: 80px;")
                                    span Game Name
                                  td
                                    span {{ item.game_name || '-' }}
                                tr
                                  td.table-header(style="width: 80px;")
                                    span Table ID
                                  td
                                    span {{ item.table_id || '-' }}
                                tr
                                  td.table-header(style="width: 80px;")
                                    span Player Hand
                                  td
                                    span {{ item.player_hand || '-' }}
                                tr
                                  td.table-header(style="width: 80px;")
                                    span Lucky No.
                                  td
                                    span {{ item.lucky_number || '-' }}
                                tr(v-if="item.remark")
                                  td.table-header(style="width: 80px;")
                                    span Remark
                                  td
                                    span {{ item.remark || '-' }}

                          template(v-if="result.item.provider_type == 'SLOTS'")
                            .d-block(v-if="item.game_name" style="line-height: 1;")
                              .text-primary #[b {{ item.game_name }}]
                            .d-block(v-if="item.remark" style="line-height: 1;")
                              .d-flex.text-zero.align-items-center
                                i.fa.fa-comment.mr-1
                                i(style="margin-bottom: 1px;") {{ item.remark }}

                          template(v-if="result.item.provider_type == 'SPORTSBOOK'")
                            table.table-details
                              tbody
                                tr
                                  td.table-header(style="width: 80px;")
                                    span {{ $t("ui.type") }}
                                  td
                                    span {{ item.sports_category || '-' }} - {{ item.bet_type || '-' }}
                                tr
                                  td.table-header
                                    span {{ $t("ui.bet") }}
                                  td
                                    span.text-primary {{ item.odds_display || '-' }}
                                    span.text-secondary.opacity-5 &nbsp;@&nbsp;
                                    span.text-secondary(v-if="item.home_running_score != null") &nbsp;[{{ item.home_running_score }}:{{ item.home_running_score }}]&nbsp;
                                    span.text-dark {{ item.bet_hand }}
                                tr
                                  td.table-header
                                    span {{ $t("ui.league") }}
                                  td
                                    span.text-dark {{ item.league_name }}
                                tr
                                  td.table-header
                                    span {{ $t("ui.time") }}
                                  td
                                    span.text-dark  {{ $moment(item.match_time).format('DD/MM/YYYY HH:mm:ss A') }}
                                template(v-if="item.home_team_name && item.home_team_name != item.away_team_name")
                                  tr
                                    td.table-header
                                      span {{ $t("ui.home") }}
                                    td
                                      span.text-secondary(v-if="item.home_score != null") [{{ item.home_score }}]&nbsp;
                                      span.text-dark {{ item.home_team_name }}
                                  tr
                                    td.table-header
                                      span {{ $t("ui.away") }}
                                    td
                                      span.text-secondary(v-if="item.away_score != null") [{{ item.away_score }}]&nbsp;
                                      span.text-dark {{ item.away_team_name }}
                                template(v-else)
                                  tr
                                    td.table-header
                                      span {{ $t("ui.team") }}
                                    td
                                      .text-xxs.text-dark {{ item.away_team_name }}
                                tr(v-if="item.remark")
                                  td.table-header
                                    span {{ $t("ui.remark") }}
                                  td
                                    span.text-xxs.text-secondary {{ item.remark || '-' }}
                        td(role="cell")
                          .text-right
                            span(
                              :class="$helpers.getNumberClass(item.turnover)"
                              )
                              | #[b {{ item.turnover | currency }}]
                        td(role="cell")
                          .text-right
                            span(
                              :class="$helpers.getNumberClass(item.valid_turnover)"
                              )
                              | #[b {{ item.valid_turnover | currency }}]
                        td(role="cell")
                          .text-right
                            span(
                              :class="$helpers.getNumberClass(item.member_winlose)"
                              )
                              | #[b {{ item.member_winlose | currency }}]
                  tbody(v-else)
                    tr
                      td(colspan=6)
                        .text-center.p-2
                          span.text-zero {{ $t('message.no_records') }}
                  tfoot(v-if="result.list.length > 0")
                    tr(role="row")
                      td(role="cell" colspan="3")
                        .text-right.text-uppercase.text-zero
                          b {{ $t("ui.total") }}
                      td(role="cell")
                        .text-right
                          span(
                            :class="$helpers.getNumberClass(result.total.turnover)"
                            )
                            | #[b {{ result.total.turnover | currency }}]
                      td(role="cell")
                        .text-right
                          span(
                            :class="$helpers.getNumberClass(result.total.valid_turnover)"
                            )
                            | #[b {{ result.total.valid_turnover | currency }}]
                      td(role="cell")
                        .text-right
                          span(
                            :class="$helpers.getNumberClass(result.total.member_winlose)"
                            )
                            | #[b {{ result.total.member_winlose | currency }}]

  #end-report.mt-3

</template>

<script>
import { required, alphaNum, minLength, maxLength, integer, email, sameAs, numeric, decimal, helpers } from "vuelidate/lib/validators";

import config from "@/config";
import errorTags from "@/errorTags";

import DateRangePicker from "@/library/DateRangePicker.vue";
import DebounceInput from "@/library/DebounceInput";
import ValidateResult from "@/library/ValidateResult";
import SubmitButton from "@/library/SubmitButton.vue";
import currency from "@/components/currency.vue";

import xhr from "@/plugins/xhr.js";

export default {
  components: {
    SubmitButton,
    DebounceInput,
    ValidateResult,
    DateRangePicker,
    currency
  },
  data() {
    return {
      loading: false,
      selectedResult: null,
      target_id: "",
      search_id: "",
      report_type: "ALL",
      agent: {
        lines: [],
        list: [],
        total: {},
        currentPage: 1,
        totalRows: 0
      },
      member: {
        lines: [],
        list: [],
        total: {},
        currentPage: 1,
        totalRows: 0
      },
      result: {
        item: {},
        list: [],
        total: {},
        currentPage: 1,
        totalRows: 0
      },
      account_id: "",
      sortBy: "account_id",
      sortDesc: false
    };
  },
  validations: {},
  computed: {
    perPage() {
      return this.$store.getters.pageSize;
    },
    direction() {
      return this.sortDesc ? "DESC" : "ASC";
    },
    dateRange() {
      return [this.$moment(this.$store.getters.dateRange[0]), this.$moment(this.$store.getters.dateRange[1])];
    },
    parentId() {
      if (this.target_id) return this.target_id;
      if (this.agent.lines.length <= 0) return null;
      return this.agent.lines[this.agent.lines.length - 1].account_id;
    }
  },
  mounted() {
    var q = this.$route.query;
    if (q["id"] != null) {
      this.search_id = q["id"];
    }
    this.getList();
  },
  methods: {
    back() {
      if (this.search_id) {
        this.$router.push("/account/accountList?id=" + this.search_id);
      }
    },
    openLink(e) {
      if (xhr.GAME[e.provider_code] == null) {
        this.$swal({
          title: this.$t("ui.error"),
          text: this.$t("error.resultNotAvailable"),
          type: "error"
        });
        return;
      }
      switch (e.provider_code) {
        case "YB":
          var url = `${xhr.GAME[e.provider_code]}?login_id=${this.$store.getters.username}`;
          url += `&player_id=${e.member_id}`;
          url += `&auth_token=${this.$store.getters.sessionToken}`;
          url += `&result_id=${e.result_id}`;
          window.open(url, e.provider_type + "_" + e.provider_code, `scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no,width=600,height=320`);
          break;

        default:
          var args = {};
          args["player_id"] = e.member_id;
          args["ticket_id"] = e.result_id;
          args["game_code"] = e.game_id;
          args["lang_code"] = "en";
          xhr
            .doGame(args, xhr.GAME[e.provider_code])
            .then(res => {
              if (res.success) {
                var data = JSON.parse(res.data);
                switch (e.provider_code) {
                  // PPS
                  case "PPS":
                    window.open(data.detail_url, e.provider_type + "_" + e.provider_code, `scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no,width=600,height=320`);
                    break;
                  // EVO
                  case "EVO":
                    window.open(data.detail_url, e.provider_type + "_" + e.provider_code, `scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no,width=600,height=605`);
                    break;
                  // EPIC
                  case "EPIC":
                    window.open(data.detail_url, e.provider_type + "_" + e.provider_code, `scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no,width=600,height=400`);
                    break;
                  // LIVE22 / UU
                  default:
                    window.open(data.detail_url, e.provider_type + "_" + e.provider_code, `scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no,width=600,height=300`);
                    break;
                }
              } else {
                this.handleError(res);
              }
            })
            .catch(res => {
              this.handleError(res);
            });
      }
    },
    selectMemberResult(e) {
      console.log("selectMemberResult")
      this.selectedResult = e;
      if (e) {
        switch (e.provider_type.toUpperCase()) {
          case "LIVECASINO":
            this.getGameResult(e, xhr.ACCOUNT.gameResultLiveCasino);
            break;
          case "SLOTS":
            this.getGameResult(e, xhr.ACCOUNT.gameResultSlots);
            break;
          case "SPORTSBOOK":
            this.getGameResult(e, xhr.ACCOUNT.gameResultSportsbook);
            break;
          default:
            this.$swal({
              title: this.$t("ui.error"),
              text: this.$t("error.resultNotAvailable"),
              type: "error"
            });
            break;
        }
      } else {
        this.reset();
      }
    },
    getGameResult(e, f) {
      var args = {
        session_token: this.$store.getters.sessionToken,
        action_by: this.$store.getters.username,
        account_id: this.$store.getters.username
      };
      args["member_id"] = e.account_id;
      args["provider_code"] = e.provider_code;
      args["page_number"] = parseInt(this.result.currentPage);
      this.result.currentPage = args["page_number"];
      args["page_size"] = this.perPage;
      args["sort_key"] = "bet_time"; // this.sortBy;
      args["sort_type"] = "DESC"; // this.direction;
      args["start_date"] = this.dateRange[0] != null ? (this.dateRange[0] != "" ? this.$moment(this.dateRange[0]).format("YYYY-MM-DD") : "") : "";
      args["end_date"] = this.dateRange[1] != null ? (this.dateRange[1] != "" ? this.$moment(this.dateRange[1]).format("YYYY-MM-DD") : "") : "";
      xhr
        .doRequest(args, f)
        .then(res => {
          this.result.list = res.data.list;
          if (res.data.total && res.data.total.length > 0) {
            this.result.total = res.data.total[0];
          }
          this.result.totalRows = res.data.list.length > 0 ? res.data.list[0]["totalrows"] : 0;
          this.result.item = e;

          // setTimeout(() => {
          //   this.$root.$emit("bv::table::refresh", "resultList");
          //   var elem = $("#end-report").offset();
          //   if (elem) {
          //     $("html, body").scrollTop(elem.top);
          //   }
          // }, 500);
        })
        .catch(res => {
          this.reset();
          this.$helpers.handleFeedback(res.status);
        });
    },
    reset() {
      console.log('reset')
      this.selectedResult = null;
      this.result.item = {};
      this.result.list = [];
      this.result.total = {};
      this.result.currentPage = 1;
      this.result.totalRows = 0;
    },
    selectMemberProvider(e) {
      var flag = e["expand"] || false;
      this.$set(e, "expand", !flag);
      this.getMemberWinLoseProvider(e);
    },
    selectMemberCode(e, f) {
      var flag = f["expand"] || false;
      this.$set(f, "expand", !flag);
      this.getMemberWinLoseCode(e, f);
    },
    selectAgentProvider(e) {
      var flag = e["expand"] || false;
      this.$set(e, "expand", !flag);
      this.getAgentWinLoseProvider(e);
    },
    selectAgentCode(e, f) {
      var flag = f["expand"] || false;
      this.$set(f, "expand", !flag);
      this.getAgentWinLoseCode(e, f);
    },
    drillIn(e) {
      this.agent.currentPage = 1;
      this.member.currentPage = 1;
      if (e == null || e == "") {
        this.target_id = "";
        this.search_id = "";
        this.getList();
      } else {
        this.target_id = e;
        this.search_id = "";
        this.getList();
      }
      this.reset();
    },
    agentChangedPage(e) {
      this.agent.currentPage = e;
      this.selectedResult = null;
      this.getAgentList();
    },
    memberChangedPage(e) {
      this.member.currentPage = e;
      this.selectedResult = null;
      this.getMemberList();
    },
    resultChangedPage(e) {
      this.result.currentPage = e;
      if (this.selectedResult) {
        this.selectMemberResult(this.selectedResult);
      }
    },
    changedPageSize(e) {
      this.$store.dispatch("layout/setPageSize", e);
      this.agent.currentPage = 1;
      this.member.currentPage = 1;
      this.getList();

      this.result.currentPage = 1;
      if (this.selectedResult) {
        this.selectMemberResult(this.selectedResult);
      }
    },
    sortingChanged(e) {
      if (e.sortBy !== this.sortBy) {
        this.sortDesc = false;
      } else {
        this.sortDesc = this.direction === "ASC";
      }
      this.sortBy = e.sortBy;
      this.getList();

      if (this.selectedResult) {
        this.selectMemberResult(this.selectedResult);
      }
    },
    getList() {
      this.getAgentList();
      this.getMemberList();
    },
    getAgentList() {
      var args = {
        session_token: this.$store.getters.sessionToken,
        action_by: this.$store.getters.username,
        source_account_id: this.$store.getters.username
      };
      args["target_account_id"] = this.target_id || "";
      args["search_id"] = this.search_id || "";
      args["all_provider"] = this.report_type == "ALL" ? 1 : 0;
      args["sportsbook"] = this.report_type == "SPORTSBOOK" ? 1 : 0;
      args["slots"] = this.report_type == "SLOTS" ? 1 : 0;
      args["livecasino"] = this.report_type == "LIVECASINO" ? 1 : 0;
      args["lottery"] = this.report_type == "LOTTERY" ? 1 : 0;
      args["page_number"] = parseInt(this.agent.currentPage);
      this.agent.currentPage = args["page_number"];
      args["page_size"] = this.perPage;
      args["sort_key"] = this.sortBy;
      args["sort_type"] = this.direction;
      args["start_date"] = this.dateRange[0] != null ? (this.dateRange[0] != "" ? this.$moment(this.dateRange[0]).format("YYYY-MM-DD") : "") : "";
      args["end_date"] = this.dateRange[1] != null ? (this.dateRange[1] != "" ? this.$moment(this.dateRange[1]).format("YYYY-MM-DD") : "") : "";
      xhr
        .doRequest(args, xhr.ACCOUNT.dailyWinLoseAgent)
        .then(res => {
          this.agent.list = res.data.ag_list;
          this.agent.lines = res.data.train;
          if (res.data.ag_total && res.data.ag_total.length > 0) {
            this.agent.total = res.data.ag_total[0];
          }
          this.agent.totalRows = res.data.ag_list.length > 0 ? res.data.ag_list[0]["totalrows"] : 0;
          this.$root.$emit("bv::table::refresh", "agentList");
        })
        .catch(res => {
          this.$helpers.handleFeedback(res.status);
        });
    },
    getMemberList() {
      var args = {
        session_token: this.$store.getters.sessionToken,
        action_by: this.$store.getters.username,
        source_account_id: this.$store.getters.username
      };
      args["target_account_id"] = this.target_id || "";
      args["search_id"] = this.search_id || "";
      args["all_provider"] = this.report_type == "ALL" ? 1 : 0;
      args["sportsbook"] = this.report_type == "SPORTSBOOK" ? 1 : 0;
      args["slots"] = this.report_type == "SLOTS" ? 1 : 0;
      args["livecasino"] = this.report_type == "LIVECASINO" ? 1 : 0;
      args["lottery"] = this.report_type == "LOTTERY" ? 1 : 0;
      args["page_number"] = parseInt(this.agent.currentPage);
      this.agent.currentPage = args["page_number"];
      args["page_size"] = this.perPage;
      args["sort_key"] = this.sortBy;
      args["sort_type"] = this.direction;
      args["start_date"] = this.dateRange[0] != null ? (this.dateRange[0] != "" ? this.$moment(this.dateRange[0]).format("YYYY-MM-DD") : "") : "";
      args["end_date"] = this.dateRange[1] != null ? (this.dateRange[1] != "" ? this.$moment(this.dateRange[1]).format("YYYY-MM-DD") : "") : "";
      xhr
        .doRequest(args, xhr.ACCOUNT.dailyWinLoseMember)
        .then(res => {
          this.member.list = res.data.mb_list;
          this.member.lines = res.data.train;
          if (res.data.mb_total && res.data.mb_total.length > 0) {
            this.member.total = res.data.mb_total[0];
          }
          this.member.totalRows = res.data.mb_list.length > 0 ? res.data.mb_list[0]["totalrows"] : 0;
          this.$root.$emit("bv::table::refresh", "memberList");
        })
        .catch(res => {
          this.$helpers.handleFeedback(res.status);
        });
    },
    getAgentWinLoseProvider(e) {
      var list = e["provider_list"] || [];
      var args = {
        session_token: this.$store.getters.sessionToken,
        action_by: this.$store.getters.username
      };
      args["account_id"] = e.account_id;
      args["all_provider"] = this.report_type == "ALL" ? 1 : 0;
      args["sportsbook"] = this.report_type == "SPORTSBOOK" ? 1 : 0;
      args["slots"] = this.report_type == "SLOTS" ? 1 : 0;
      args["livecasino"] = this.report_type == "LIVECASINO" ? 1 : 0;
      args["lottery"] = this.report_type == "LOTTERY" ? 1 : 0;
      args["start_date"] = this.dateRange[0] != null ? (this.dateRange[0] != "" ? this.$moment(this.dateRange[0]).format("YYYY-MM-DD") : "") : "";
      args["end_date"] = this.dateRange[1] != null ? (this.dateRange[1] != "" ? this.$moment(this.dateRange[1]).format("YYYY-MM-DD") : "") : "";
      xhr
        .doRequest(args, xhr.ACCOUNT.dailyWinLoseProvider)
        .then(res => {
          list = res.data.ag_list;
          // if (res.data.ag_total && res.data.ag_total.length > 0) {
          //   total = res.data.ag_total[0];
          // }
          this.$set(e, "provider_list", list);
        })
        .catch(res => {
          this.$helpers.handleFeedback(res.status);
          this.$set(e, "provider_list", []);
        });
    },
    getAgentWinLoseCode(e, f) {
      var list = f["code_list"] || [];
      var args = {
        session_token: this.$store.getters.sessionToken,
        action_by: this.$store.getters.username
      };
      args["account_id"] = f.account_id;
      args["provider_type"] = f.provider_type;
      args["start_date"] = this.dateRange[0] != null ? (this.dateRange[0] != "" ? this.$moment(this.dateRange[0]).format("YYYY-MM-DD") : "") : "";
      args["end_date"] = this.dateRange[1] != null ? (this.dateRange[1] != "" ? this.$moment(this.dateRange[1]).format("YYYY-MM-DD") : "") : "";
      xhr
        .doRequest(args, xhr.ACCOUNT.dailyWinLoseCode)
        .then(res => {
          list = res.data.ag_list;
          // if (res.data.ag_total && res.data.ag_total.length > 0) {
          //   total = res.data.ag_total[0];
          // }
          this.$set(f, "code_list", list);
        })
        .catch(res => {
          this.$helpers.handleFeedback(res.status);
          this.$set(f, "code_list", []);
        });
    },
    getMemberWinLoseProvider(e) {
      var list = e["provider_list"] || [];
      var args = {
        session_token: this.$store.getters.sessionToken,
        action_by: this.$store.getters.username
      };
      args["account_id"] = this.parentId;
      args["search_id"] = e.account_id;
      args["all_provider"] = this.report_type == "ALL" ? 1 : 0;
      args["sportsbook"] = this.report_type == "SPORTSBOOK" ? 1 : 0;
      args["slots"] = this.report_type == "SLOTS" ? 1 : 0;
      args["livecasino"] = this.report_type == "LIVECASINO" ? 1 : 0;
      args["lottery"] = this.report_type == "LOTTERY" ? 1 : 0;
      args["start_date"] = this.dateRange[0] != null ? (this.dateRange[0] != "" ? this.$moment(this.dateRange[0]).format("YYYY-MM-DD") : "") : "";
      args["end_date"] = this.dateRange[1] != null ? (this.dateRange[1] != "" ? this.$moment(this.dateRange[1]).format("YYYY-MM-DD") : "") : "";
      xhr
        .doRequest(args, xhr.ACCOUNT.dailyWinLoseProvider)
        .then(res => {
          list = res.data.ag_list;
          this.$set(e, "provider_list", list);
        })
        .catch(res => {
          this.$helpers.handleFeedback(res.status);
          this.$set(e, "provider_list", []);
        });
    },
    getMemberWinLoseCode(e, f) {
      var list = f["code_list"] || [];
      var args = {
        session_token: this.$store.getters.sessionToken,
        action_by: this.$store.getters.username
      };
      args["account_id"] = this.parentId;
      args["search_id"] = f.account_id;
      args["provider_type"] = f.provider_type;
      args["start_date"] = this.dateRange[0] != null ? (this.dateRange[0] != "" ? this.$moment(this.dateRange[0]).format("YYYY-MM-DD") : "") : "";
      args["end_date"] = this.dateRange[1] != null ? (this.dateRange[1] != "" ? this.$moment(this.dateRange[1]).format("YYYY-MM-DD") : "") : "";
      xhr
        .doRequest(args, xhr.ACCOUNT.dailyWinLoseCode)
        .then(res => {
          list = res.data.ag_list;
          this.$set(f, "code_list", list);
        })
        .catch(res => {
          this.$helpers.handleFeedback(res.status);
          this.$set(f, "code_list", []);
        });
    }
  }
};
</script>
